import {Pipe, PipeTransform} from '@angular/core';
import {EpProductionScheduleItemInPathGroup} from '@domain/production-schedule/ep-production-schedule-item-in-path-group';
import {TranslateService, Unit} from '@vdw/angular-component-library';
import {CalculateDimensionsBasePipe} from '../calculate-dimensions-base-pipe';

@Pipe({
  name: 'calculateCutbarsDimensionsForProductionScheduleItem'
})
export class CalculateCutbarsDimensionsForProductionScheduleItemPipe extends CalculateDimensionsBasePipe implements PipeTransform {
  public constructor(translate: TranslateService) {
    super(translate);
  }

  public transform(productionScheduleItem: EpProductionScheduleItemInPathGroup, displayTechnicalUnit: boolean, commercialUnit: Unit): string {
    let cutbarBeforeLength = 0;
    let cutbarAfterLength = 0;

    const {cutbarBefore, cutbarAfter} = productionScheduleItem.getCutbarInformation();
    const unit = this.getUnitLabel(displayTechnicalUnit, Unit.PICKS, commercialUnit);

    if (displayTechnicalUnit) {
      cutbarBeforeLength = cutbarBefore.technicalLengthInNumberOfPicks;
      cutbarAfterLength = cutbarAfter.technicalLengthInNumberOfPicks;
    } else {
      cutbarBeforeLength = cutbarBefore.commercialLengthInMM;
      cutbarAfterLength = cutbarAfter.commercialLengthInMM;
    }

    return `b: ${this.calculateDimensions(cutbarBeforeLength, displayTechnicalUnit, commercialUnit)} ${unit} / a: ${this.calculateDimensions(
      cutbarAfterLength,
      displayTechnicalUnit,
      commercialUnit
    )} ${unit}`;
  }
}
